import React, { ReactNode } from "react";

import { Modal, Button } from "@stellar/design-system";

import "./styles.scss";

type ButtonAction = {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary" | "tertiary" | "error" | "destructive";
  disabled?: boolean;
  isLoading?: boolean;
};
interface DialogModalProps {
  visible: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  primaryAction?: ButtonAction;
  secondaryAction?: ButtonAction;
  footerAlignment?: "right" | "stretch" | "stack";
  width?: "original" | "75" | "60" | "50";
  parentId?: string;
  xButton?: boolean;
}

export const DialogModal = ({
  visible,
  onClose,
  title,
  children,
  primaryAction,
  secondaryAction,
  footerAlignment = "right",
  parentId = "root",
  width = "original",
  xButton = true,
}: DialogModalProps) => {
  const hasFooter = Boolean(primaryAction || secondaryAction);
  const markerClass = [
    "DialogModal__marker",
    width !== "original" ? `DialogModal__marker--${width}` : null,
    xButton ? null : "DialogModal__xButton",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Modal visible={visible} onClose={onClose} parentId={parentId} className="DialogModal">
      {title && <Modal.Heading>{title}</Modal.Heading>}
      <Modal.Body>
        <div className={markerClass}>
          <div className="DialogModal__content">{children}</div>
        </div>
      </Modal.Body>

      {hasFooter && (
        <Modal.Footer itemAlignment={footerAlignment}>
          {primaryAction && (
            <Button
              size="md"
              variant={primaryAction.variant || "primary"}
              onClick={primaryAction.onClick}
              disabled={primaryAction.disabled}
              isLoading={primaryAction.isLoading}
            >
              {primaryAction.label}
            </Button>
          )}

          {secondaryAction && (
            <Button
              size="md"
              variant={secondaryAction.variant || "tertiary"}
              onClick={secondaryAction.onClick}
              disabled={secondaryAction.disabled}
              isLoading={secondaryAction.isLoading}
            >
              {secondaryAction.label}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};
